import { Controller } from '@hotwired/stimulus';
import application from '~/stimulus_application';

export default class TableRow extends Controller {
  static values = {
    url: String,
  };

  declare readonly urlValue: string;
  declare readonly hasUrlValue: boolean;

  stop(event: Event) {
    event.stopPropagation();
  }

  navigate(event: Event) {
    // Don't navigate if clicking on an action link
    if ((event.target as HTMLElement).closest('a')) {
      return;
    }

    if (this.hasUrlValue) {
      Turbo.visit(this.urlValue);
    }
  }
}

application.register('ui--table-row', TableRow);
